import { template as template_50aad3b42f35488abaa4df7312924521 } from "@ember/template-compiler";
import { componentFor } from 'client-portal/utils/clinicianSearch/facets/manifest';
import Component from '@glimmer/component';
export default class RequestClinicianSearchFacetFilterContent extends Component {
    get facetComponent() {
        return componentFor(this.args.facetName);
    }
    static{
        template_50aad3b42f35488abaa4df7312924521(`
    {{#if this.facetComponent}}
      <this.facetComponent />
    {{/if}}
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
